import type { FaireBrandEntity } from "../../entity_types/brand";

// Do Good Candle Studio — real Faire brand (b_3umm7l0w4u). Identity metadata from
// ANALYTICS.CANONICAL.BRANDS; backs the ads-manager-2 "Do Good Candle Studio"
// real-brand variant (advertiser 3706895363597287505).
//
// Unlike Dairy Brand and Textile Brand, this one is NOT anonymized — it is shown
// under its own name because the variant exists to put a specific brand's own
// numbers in front of them during research. Anonymize it before showing this
// state to anyone else.
export const b_3umm7l0w4u: FaireBrandEntity = {
  token: "b_3umm7l0w4u",
  type: "brand",
  name: "Do Good Candle Studio",
  description: "Non-toxic soy candles and reed diffusers.",
  location: "Fargo, ND, USA",
  isTopShop: true,
  tags: ["home-decor", "candles", "reed-diffusers"],
  meta: {
    source: "snowflake",
    importedAt: "2026-09-21T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
